function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import * as randomstring from 'randomstring';
import { Domain } from '@pushly/models/lib/structs/domain';
import { NotificationAction } from '@pushly/models/lib/structs/notification-action';
import { Drawer } from '../drawer/drawer';
import { getClassNames, getDomainDefaultActionLabels, getNotificationActionOrDefault, isDef, minutesToSeconds, noop, prepareDomainAllowList, secondsToMinutes, simpleFormErrorNotification, simpleNotification, waitForDefined } from '../../utils';
import { Button, Form, Input } from 'antd';
import { DEFAULT_DRAWER_FORM_ITEM_LAYOUT } from '../../constants';
import { FileUploader, NotificationActionBuilder as NotifActionBuilder, Well } from '../index';
import StackedTagSelect from '../stacked-tag-select/stacked-tag-select';
import { DeleteFilled, InfoCircleOutlined, PlusOutlined, SettingOutlined } from '@ant-design/icons';
import { calculateRawTtlSecondsFromValue, TtlEditorElement } from '../ttl-element/ttl-element';
import { DomainDeliveryEditor } from '../domain-delivery/domain-delivery-element';
import TemplatizedTextField from '../templatized-text-field/templatized-text-field';
import { camelCase } from 'change-case';
import './style/domain-notification-settings.scss';
import { NotificationDeliveryType } from '../../enums/notification-delivery-type';
import { NotificationDeliveryWindow } from '../../enums/notification-delivery-window';
import clone from 'clone-deep';
import deepEqual from 'react-fast-compare';
import { useScrollIntoView } from '../../hooks/use-scroll-into-view';
import { DomainUtmParams } from '@pushly/models/lib/structs/domain-utm-params';
import { InvalidFieldException } from '@pushly/models/lib/exceptions/invalid-field-exception';
import { MissingFieldException } from '@pushly/models/lib/exceptions/missing-field-exception';
import { extractFriendlyErrorMessage, extractMinMaxFriendlyError } from '../../utils/exception';
import { NotificationFrequencyCapsConfig } from '@pushly/models/lib/structs/notification-frequency-caps-config';
import { determineMinMax, extractUIFriendlyCap, NotificationFrequencyCapsFormEditor } from '../notification-frequency-caps/notification-frequency-caps';
import { convertToMinutes } from '../../utils/time';
import { DeliveryThrottlingEditor } from '../notification-delivery-throttling/delivery-throttling-editor';
var domainUtmParameterKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
var utmMacroTypes = ['domain', 'device', 'location', 'notification', 'custom'];

var hydrateNotificationActions = function hydrateNotificationActions(domain) {
  var _domain$defaultNotifi;

  return ((_domain$defaultNotifi = domain.defaultNotificationActions) !== null && _domain$defaultNotifi !== void 0 ? _domain$defaultNotifi : []).map(function (a) {
    return NotificationAction.Builder.setOrdinal(a.ordinal).setType(a.type).setId(a.id).setLabel(a.label).setLandingUrl(a.landingUrl).setUsePrimaryLandingUrl(a.usePrimaryLandingUrl).setDisplayMeta(a.displayMeta);
  });
};

export var defaultFreqCap = {
  value: 1,
  durationMinutes: 60,
  displayMetric: 'minutes'
}; // this is a stub until we can upgrade AQE to take full advantage of models library updates

export var DomainNotificationEditor = function DomainNotificationEditor(props) {
  var _domain$notificationF, _domain$addedNotifica, _domain$defaultNotifi2;

  var domain = props.domain,
      getAppContainer = props.getAppContainer,
      visible = props.visible,
      defaultOpenUrlLabelEnabled = props.defaultOpenUrlLabelEnabled,
      showInternalEditorAccess = props.showInternalEditorAccess,
      fetchCustomMacroFields = props.fetchCustomMacroFields,
      onSubmit = props.onSubmit;

  var _useScrollIntoView = useScrollIntoView('lastElementChild'),
      _useScrollIntoView2 = _slicedToArray(_useScrollIntoView, 2),
      ref = _useScrollIntoView2[0],
      setScrolling = _useScrollIntoView2[1];

  var _React$useState = React.useState(!!((_domain$notificationF = domain.notificationFrequencyCaps) !== null && _domain$notificationF !== void 0 && _domain$notificationF[0])),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      capsEnabled = _React$useState2[0],
      setCapsEnabled = _React$useState2[1];

  var _React$useState3 = React.useState(domain.deliveryThrottleMaxSeconds > 0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      throttleEnabled = _React$useState4[0],
      setThrottleEnabled = _React$useState4[1];

  var customMacroOptions = React.useRef();

  var _React$useState5 = React.useState(Object.entries(clone((_domain$addedNotifica = domain.addedNotificationQueryParams) !== null && _domain$addedNotifica !== void 0 ? _domain$addedNotifica : {}))),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      customUtmParams = _React$useState6[0],
      setCustomUtmParams = _React$useState6[1];

  var _React$useState7 = React.useState(hydrateNotificationActions(domain)),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      defaultActions = _React$useState8[0],
      setDefaultActions = _React$useState8[1];

  var defaultPrimaryAction = getNotificationActionOrDefault(domain, 0);
  var domainDefaultLabels = getDomainDefaultActionLabels(domain);
  var primaryAction = getNotificationActionOrDefault(domain, 0, defaultActions);
  var secondaryAction = getNotificationActionOrDefault(domain, 1, defaultActions);
  var rootActions = [primaryAction];

  if (secondaryAction) {
    rootActions.push(secondaryAction);
  }

  React.useEffect(function () {
    var customPrimaryDefined = defaultActions.find(function (a) {
      return a.ordinal === 0;
    });

    if (!customPrimaryDefined) {
      setDefaultActions([].concat(_toConsumableArray(defaultActions), [defaultPrimaryAction]));
    }
  }, [defaultActions]); // reset when domain has been updated

  React.useEffect(function () {
    setDefaultActions(hydrateNotificationActions(domain));
  }, [(_domain$defaultNotifi2 = domain.defaultNotificationActions) === null || _domain$defaultNotifi2 === void 0 ? void 0 : _domain$defaultNotifi2.length]);

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0]; // ============================ Notification Action Handlers ============================


  var addOrRemoveAction = function addOrRemoveAction(action) {
    var _ref;

    var defaults = _toConsumableArray((_ref = defaultActions !== null && defaultActions !== void 0 ? defaultActions : domain.defaultNotificationActions) !== null && _ref !== void 0 ? _ref : []);

    var actionIdx = defaults.findIndex(function (a) {
      return a.ordinal === action.ordinal;
    });

    if (actionIdx < 0) {
      defaults.push(action);
    } else {
      defaults.splice(actionIdx, 1, action);
    }

    return defaults;
  };

  var handleActionAdd = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              action.setDisplayMeta(_objectSpread(_objectSpread({}, action.displayMeta), {}, {
                eid: randomstring.generate()
              }));
              _context.next = 3;
              return setDefaultActions(addOrRemoveAction(action));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleActionAdd(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleActionUpdate = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(action) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return setDefaultActions(addOrRemoveAction(action));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleActionUpdate(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleActionRemove = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(action) {
      var _ref5;

      var defaults, actionIdx;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              defaults = _toConsumableArray((_ref5 = defaultActions !== null && defaultActions !== void 0 ? defaultActions : domain.defaultNotificationActions) !== null && _ref5 !== void 0 ? _ref5 : []);
              actionIdx = defaults.findIndex(function (a) {
                return a.ordinal === action.ordinal;
              });

              if (!(actionIdx !== -1)) {
                _context3.next = 6;
                break;
              }

              defaults.splice(actionIdx, 1);
              _context3.next = 6;
              return setDefaultActions(defaults);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleActionRemove(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handlePrimaryActionAdd = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(action) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              action.setOrdinal(0);
              _context4.next = 3;
              return handleActionAdd(action);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handlePrimaryActionAdd(_x4) {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleSecondaryActionAdd = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(action) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              action.setOrdinal(1);
              _context5.next = 3;
              return handleActionAdd(action);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleSecondaryActionAdd(_x5) {
      return _ref7.apply(this, arguments);
    };
  }(); // ============================ Drawer Handler ============================


  var handleCustomUtmRemove = function handleCustomUtmRemove(index) {
    setCustomUtmParams(function (prev) {
      var params = _toConsumableArray(prev);

      params.splice(index, 1);
      return params;
    });
  };

  var handleCustomUtmAdd = function handleCustomUtmAdd() {
    setCustomUtmParams(function (prev) {
      var params = _toConsumableArray(prev);

      params.push(['', {
        "default": '',
        property: '__explicit'
      }]);
      return params;
    });
    setScrolling(true);
  };

  var handleCustomUtmChange = function handleCustomUtmChange(index, name, value) {
    var customValue = _toConsumableArray(customUtmParams);

    customValue[index][0] = name.trim().replace(/\s/g, '_');
    customValue[index][1]["default"] = value;
    setCustomUtmParams(customValue);
  };

  var getCurrentValues = function getCurrentValues() {
    var _formValues$landingUr, _domain$landingUrlDom, _formValues$defaultIc, _formValues$defaultIc2, _domain$defaultIconUr, _formValues$defaultBa, _formValues$defaultBa2, _domain$defaultBadgeU, _domain$utmParams, _domain$addedNotifica2;

    var values = Domain.Builder;
    var formValues = form.getFieldsValue(true); // Landing URL Domain Whitelist

    if (!deepEqual((_formValues$landingUr = formValues.landingUrlDomainWhitelist) !== null && _formValues$landingUr !== void 0 ? _formValues$landingUr : [], (_domain$landingUrlDom = domain.landingUrlDomainWhitelist) !== null && _domain$landingUrlDom !== void 0 ? _domain$landingUrlDom : [])) {
      values.setLandingUrlDomainWhitelist(formValues.landingUrlDomainWhitelist);
    } // Actions


    if (defaultOpenUrlLabelEnabled) {
      var _domain$defaultNotifi3;

      if (formValues.defaultOpenUrlLabel !== ((_domain$defaultNotifi3 = domain.defaultNotificationActionLabels) === null || _domain$defaultNotifi3 === void 0 ? void 0 : _domain$defaultNotifi3.openUrl)) {
        var _formValues$defaultOp;

        var openUrl = ((_formValues$defaultOp = formValues.defaultOpenUrlLabel) !== null && _formValues$defaultOp !== void 0 ? _formValues$defaultOp : '').toString().trim();
        var defaultActionLabels = {};

        if (openUrl) {
          var _domain$defaultNotifi4;

          defaultActionLabels = _objectSpread(_objectSpread({}, (_domain$defaultNotifi4 = domain.defaultNotificationActionLabels) !== null && _domain$defaultNotifi4 !== void 0 ? _domain$defaultNotifi4 : {}), {}, {
            open_url: openUrl
          });
        }

        values.setDefaultNotificationActionLabels(defaultActionLabels);
      }
    }

    var actions = defaultActions;
    var newActions;

    if (Array.isArray(actions) && actions.length) {
      var _actions$find;

      // remove UI codes
      var actionIsDefault = (_actions$find = actions.find(function (a) {
        return a.ordinal === 0;
      })) === null || _actions$find === void 0 ? void 0 : _actions$find.equals(defaultPrimaryAction, {
        omittingKeys: ['displayMeta']
      });
      var skipAddDefaultAction = actions.length === 1 && actionIsDefault && domain.defaultNotificationActions === null;
      newActions = actions.map(function (a, idx) {
        var _getNotificationActio;

        return (_getNotificationActio = getNotificationActionOrDefault(domain, idx, actions)) === null || _getNotificationActio === void 0 ? void 0 : _getNotificationActio.setDisplayMeta(undefined).build();
      });

      if (!skipAddDefaultAction && actions.length && !deepEqual(newActions, domain.defaultNotificationActions)) {
        var _newActions;

        values.setDefaultNotificationActions((_newActions = newActions) !== null && _newActions !== void 0 ? _newActions : []);
      }
    }

    if (showInternalEditorAccess) {
      var _domain$notificationF2, _domain$notificationF3, _domain$notificationF4;

      var _displayMeta = _objectSpread({}, domain.displayMeta); // Lifespan


      var ttlValue = formValues.ttlValue;
      var ttlMetric = formValues.ttlMetric;
      var computedTtlSeconds = calculateRawTtlSecondsFromValue(ttlValue, ttlMetric);

      if (computedTtlSeconds !== domain.defaultNotificationTtlSeconds) {
        values.setDefaultNotificationTtlSeconds(computedTtlSeconds);
        _displayMeta.default_notification_ttl_metric = ttlMetric;
      } // Delivery Type/Strategy


      if (formValues.defaultDeliveryTypeValue && form.isFieldTouched('defaultDeliveryTypeValue')) {
        _displayMeta.default_delivery_type = formValues.defaultDeliveryTypeValue;
      }

      if (formValues.defaultDeliveryWindowValue && form.isFieldTouched('defaultDeliveryWindowValue')) {
        _displayMeta.default_delivery_window = formValues.defaultDeliveryWindowValue;
      }

      if (!deepEqual(domain.displayMeta, _displayMeta)) {
        values.setDisplayMeta(_displayMeta);
      } // null values is seperated from new cap values


      var formFreqCaps = capsEnabled ? formValues.notificationFrequencyCaps : null;
      var newFreqCaps = [];

      if (formFreqCaps !== null) {
        var calculatedDurationMinutes = convertToMinutes(parseInt(formFreqCaps.durationMinutes, 10), formFreqCaps.displayMetric);

        try {
          newFreqCaps.push(NotificationFrequencyCapsConfig.Builder.setValue(parseInt(formFreqCaps.value, 10)).setDurationMinutes(calculatedDurationMinutes).setDisplayMetric(formFreqCaps.displayMetric).build());
        } catch (error) {
          // custom friendly error extraction specific to freq caps implementation
          if (error instanceof InvalidFieldException || error instanceof MissingFieldException) {
            var constraint = error.constraint;
            var field = error.field;

            if (field === 'durationMinutes' && (constraint === 'max' || constraint === 'min')) {
              var metric = formFreqCaps.displayMetric;
              var minMax = determineMinMax(metric);
              throw extractMinMaxFriendlyError(error, minMax, metric, {
                antdFormat: true
              });
            } else {
              // rethrow as other errors can be extracted from base validation messages/failure reasons
              throw error;
            }
          }
        }
      }

      if ((_domain$notificationF2 = domain.notificationFrequencyCaps) !== null && _domain$notificationF2 !== void 0 && _domain$notificationF2[0] && formFreqCaps === null || newFreqCaps.length && !newFreqCaps[0].equals((_domain$notificationF3 = (_domain$notificationF4 = domain.notificationFrequencyCaps) === null || _domain$notificationF4 === void 0 ? void 0 : _domain$notificationF4[0]) !== null && _domain$notificationF3 !== void 0 ? _domain$notificationF3 : new NotificationFrequencyCapsConfig())) {
        values.setNotificationFrequencyCaps(formFreqCaps === null ? null : newFreqCaps);
      }

      var formThrottleSeconds = throttleEnabled ? formValues.deliveryThrottleMaxSeconds : 0;
      var deliveryThrottleMaxSeconds = minutesToSeconds(parseInt(formThrottleSeconds, 10));

      if (!deepEqual(domain.deliveryThrottleMaxSeconds, deliveryThrottleMaxSeconds)) {
        values.setDeliveryThrottleMaxSeconds(deliveryThrottleMaxSeconds);
      } // Media Quality


      var mediaQuality = parseInt((formValues === null || formValues === void 0 ? void 0 : formValues.mediaQuality) || 40);

      if (!isDef(domain.mediaQuality) && mediaQuality !== 40 || isDef(domain.mediaQuality) && mediaQuality !== domain.mediaQuality) {
        values.setMediaQuality(mediaQuality);
      }
    } // Media Assets


    if (((_formValues$defaultIc = (_formValues$defaultIc2 = formValues.defaultIcon) === null || _formValues$defaultIc2 === void 0 ? void 0 : _formValues$defaultIc2.url) !== null && _formValues$defaultIc !== void 0 ? _formValues$defaultIc : null) !== ((_domain$defaultIconUr = domain.defaultIconUrl) !== null && _domain$defaultIconUr !== void 0 ? _domain$defaultIconUr : null)) {
      var _formValues$defaultIc3;

      values.setDefaultIconUrl(((_formValues$defaultIc3 = formValues.defaultIcon) === null || _formValues$defaultIc3 === void 0 ? void 0 : _formValues$defaultIc3.url) === undefined ? null : formValues.defaultIcon.url);
    }

    if (((_formValues$defaultBa = (_formValues$defaultBa2 = formValues.defaultBadge) === null || _formValues$defaultBa2 === void 0 ? void 0 : _formValues$defaultBa2.url) !== null && _formValues$defaultBa !== void 0 ? _formValues$defaultBa : null) !== ((_domain$defaultBadgeU = domain.defaultBadgeUrl) !== null && _domain$defaultBadgeU !== void 0 ? _domain$defaultBadgeU : null)) {
      var _formValues$defaultBa3;

      values.setDefaultBadgeUrl(((_formValues$defaultBa3 = formValues.defaultBadge) === null || _formValues$defaultBa3 === void 0 ? void 0 : _formValues$defaultBa3.url) === undefined ? null : formValues.defaultBadge.url);
    } // UTM Params


    var utmValues = DomainUtmParams.Builder;

    if (formValues.utmSource) {
      utmValues.setUtmSource(formValues.utmSource);
    }

    if (formValues.utmContent) {
      utmValues.setUtmContent(formValues.utmContent);
    }

    if (formValues.utmMedium) {
      utmValues.setUtmMedium(formValues.utmMedium);
    }

    if (formValues.utmCampaign) {
      utmValues.setUtmCampaign(formValues.utmCampaign);
    }

    if (formValues.utmTerm) {
      utmValues.setUtmTerm(formValues.utmTerm);
    }

    var newParams = utmValues.build(); // initial value could be null

    if (!newParams.equals((_domain$utmParams = domain.utmParams) !== null && _domain$utmParams !== void 0 ? _domain$utmParams : DomainUtmParams.Builder.build())) {
      values.setUtmParams(newParams);
    } // handle custom utm extraction


    var addedNotificationQueryParams = {};

    if (customUtmParams.length) {
      for (var _i2 = 0, _arr2 = _toConsumableArray(customUtmParams); _i2 < _arr2.length; _i2++) {
        var _arr2$_i = _slicedToArray(_arr2[_i2], 2),
            param = _arr2$_i[0],
            config = _arr2$_i[1];

        addedNotificationQueryParams[param] = config;
      }
    }

    if (!deepEqual(addedNotificationQueryParams, (_domain$addedNotifica2 = domain.addedNotificationQueryParams) !== null && _domain$addedNotifica2 !== void 0 ? _domain$addedNotifica2 : {})) {
      values.setAddedNotificationQueryParams(addedNotificationQueryParams);
    }

    return values;
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var mergedValues, _i3, _arr3, _config$default, _arr3$_i, param, config, uniqueParamKeys, ok;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return form.validateFields();

            case 3:
              mergedValues = getCurrentValues();

              if (mergedValues.landingUrlDomainWhitelist) {
                mergedValues.setLandingUrlDomainWhitelist(prepareDomainAllowList(Array.from(mergedValues.landingUrlDomainWhitelist), true));
              }

              if (!customUtmParams.length) {
                _context6.next = 17;
                break;
              }

              _i3 = 0, _arr3 = _toConsumableArray(customUtmParams);

            case 7:
              if (!(_i3 < _arr3.length)) {
                _context6.next = 14;
                break;
              }

              _arr3$_i = _slicedToArray(_arr3[_i3], 2), param = _arr3$_i[0], config = _arr3$_i[1];

              if (!(!(param !== null && param !== void 0 && param.trim()) || !((_config$default = config["default"]) !== null && _config$default !== void 0 && _config$default.trim()))) {
                _context6.next = 11;
                break;
              }

              throw {
                customUtmParams: {
                  errors: [{
                    message: 'Custom UTM parameter name and value are both required.'
                  }]
                }
              };

            case 11:
              _i3++;
              _context6.next = 7;
              break;

            case 14:
              uniqueParamKeys = new Set(new Map(customUtmParams).keys());

              if (!(uniqueParamKeys.size < customUtmParams.length)) {
                _context6.next = 17;
                break;
              }

              throw {
                customUtmParams: {
                  errors: [{
                    message: 'Custom UTM Param names must be unique.'
                  }]
                }
              };

            case 17:
              _context6.next = 19;
              return onSubmit(mergedValues);

            case 19:
              ok = _context6.sent;

              if (ok) {
                handleDrawerClose();
              }

              _context6.next = 27;
              break;

            case 23:
              _context6.prev = 23;
              _context6.t0 = _context6["catch"](0);

              if (_context6.t0 instanceof InvalidFieldException || _context6.t0 instanceof MissingFieldException) {
                _context6.t0 = extractFriendlyErrorMessage(_context6.t0, {
                  antdFormat: true
                });
              }

              simpleFormErrorNotification(_context6.t0);

            case 27:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 23]]);
    }));

    return function handleSubmit() {
      return _ref8.apply(this, arguments);
    };
  }(); // ============================ Drawer Handler ============================


  var handleDrawerClose = function handleDrawerClose() {
    setDefaultActions([]);
    props.onClose(null);
  };

  React.useEffect(function () {
    var initializeCustomMacroFields = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return fetchCustomMacroFields(domain.id);

              case 2:
                customMacroOptions.current = _context7.sent;

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function initializeCustomMacroFields() {
        return _ref9.apply(this, arguments);
      };
    }();

    initializeCustomMacroFields();
  }, [domain.id, form]);

  function render() {
    var _domain$notificationF5, _domain$displayMeta$d, _domain$displayMeta, _domain$displayMeta$d2, _domain$displayMeta2, _domain$mediaQuality, _domain$utmParams$utm, _domain$utmParams2, _domain$utmParams3, _domain$utmParams$utm2, _domain$utmParams4, _domain$utmParams5, _domain$utmParams$utm3, _domain$utmParams6, _domain$utmParams7, _domain$utmParams$utm4, _domain$utmParams8, _domain$utmParams9, _domain$utmParams$utm5, _domain$utmParams10, _domain$utmParams11, _domain$mediaQuality2, _domain$mediaQuality3;

    var isChildDomain = domain.prodDomainId !== null;
    var freqCap = extractUIFriendlyCap((_domain$notificationF5 = domain.notificationFrequencyCaps) === null || _domain$notificationF5 === void 0 ? void 0 : _domain$notificationF5[0]) || defaultFreqCap;
    return /*#__PURE__*/React.createElement(Drawer, {
      destroyOnClose: true,
      getContainer: getAppContainer,
      className: getClassNames('ddf-notif-settings-editor'),
      title: "Update General Settings",
      placement: "right",
      closable: true,
      onSubmit: handleSubmit,
      onClose: handleDrawerClose,
      visible: visible
    }, /*#__PURE__*/React.createElement(Form, _extends({}, DEFAULT_DRAWER_FORM_ITEM_LAYOUT, {
      form: form,
      preserve: false,
      className: "hide-inline-errors",
      autoComplete: "off",
      size: "middle",
      initialValues: {
        landingUrlDomainWhitelist: domain.landingUrlDomainWhitelist,
        defaultOpenUrlLabel: domainDefaultLabels.openUrl,
        defaultDeliveryTypeValue: (_domain$displayMeta$d = domain === null || domain === void 0 ? void 0 : (_domain$displayMeta = domain.displayMeta) === null || _domain$displayMeta === void 0 ? void 0 : _domain$displayMeta.default_delivery_type) !== null && _domain$displayMeta$d !== void 0 ? _domain$displayMeta$d : NotificationDeliveryType.IMMEDIATE,
        defaultDeliveryWindowValue: (_domain$displayMeta$d2 = domain === null || domain === void 0 ? void 0 : (_domain$displayMeta2 = domain.displayMeta) === null || _domain$displayMeta2 === void 0 ? void 0 : _domain$displayMeta2.default_delivery_window) !== null && _domain$displayMeta$d2 !== void 0 ? _domain$displayMeta$d2 : NotificationDeliveryWindow.STANDARD,
        deliveryThrottleMaxSeconds: secondsToMinutes(domain.deliveryThrottleMaxSeconds),
        mediaQuality: (_domain$mediaQuality = domain.mediaQuality) !== null && _domain$mediaQuality !== void 0 ? _domain$mediaQuality : 40,
        defaultIcon: !domain.defaultIconUrl ? undefined : {
          url: domain.defaultIconUrl
        },
        defaultBadge: !domain.defaultBadgeUrl ? undefined : {
          url: domain.defaultBadgeUrl
        },
        notificationFrequencyCaps: freqCap,
        utmSource: (_domain$utmParams$utm = (_domain$utmParams2 = domain.utmParams) === null || _domain$utmParams2 === void 0 ? void 0 : _domain$utmParams2.utm_source) !== null && _domain$utmParams$utm !== void 0 ? _domain$utmParams$utm : (_domain$utmParams3 = domain.utmParams) === null || _domain$utmParams3 === void 0 ? void 0 : _domain$utmParams3.utmSource,
        utmMedium: (_domain$utmParams$utm2 = (_domain$utmParams4 = domain.utmParams) === null || _domain$utmParams4 === void 0 ? void 0 : _domain$utmParams4.utm_medium) !== null && _domain$utmParams$utm2 !== void 0 ? _domain$utmParams$utm2 : (_domain$utmParams5 = domain.utmParams) === null || _domain$utmParams5 === void 0 ? void 0 : _domain$utmParams5.utmMedium,
        utmCampaign: (_domain$utmParams$utm3 = (_domain$utmParams6 = domain.utmParams) === null || _domain$utmParams6 === void 0 ? void 0 : _domain$utmParams6.utm_campaign) !== null && _domain$utmParams$utm3 !== void 0 ? _domain$utmParams$utm3 : (_domain$utmParams7 = domain.utmParams) === null || _domain$utmParams7 === void 0 ? void 0 : _domain$utmParams7.utmCampaign,
        utmTerm: (_domain$utmParams$utm4 = (_domain$utmParams8 = domain.utmParams) === null || _domain$utmParams8 === void 0 ? void 0 : _domain$utmParams8.utm_term) !== null && _domain$utmParams$utm4 !== void 0 ? _domain$utmParams$utm4 : (_domain$utmParams9 = domain.utmParams) === null || _domain$utmParams9 === void 0 ? void 0 : _domain$utmParams9.utmTerm,
        utmContent: (_domain$utmParams$utm5 = (_domain$utmParams10 = domain.utmParams) === null || _domain$utmParams10 === void 0 ? void 0 : _domain$utmParams10.utm_content) !== null && _domain$utmParams$utm5 !== void 0 ? _domain$utmParams$utm5 : (_domain$utmParams11 = domain.utmParams) === null || _domain$utmParams11 === void 0 ? void 0 : _domain$utmParams11.utmContent
      }
    }), /*#__PURE__*/React.createElement(Well, {
      title: "Landing URLs",
      mode: "ghost",
      hideFooter: true
    }, /*#__PURE__*/React.createElement(Form.Item, {
      label: "Domain Allow List",
      className: getClassNames('ddf-notif-editor-whitelist')
    }, /*#__PURE__*/React.createElement(Form.Item, {
      name: "landingUrlDomainWhitelist",
      noStyle: true
    }, /*#__PURE__*/React.createElement(StackedTagSelect, {
      size: "middle",
      mode: "tags",
      className: "domains-allowed",
      placeholder: "* (Any domain)",
      getPopupContainer: getAppContainer,
      tokenSeparators: [',', ';', ' ', '\n'],
      showOptions: false,
      notFoundContent: ""
    })), /*#__PURE__*/React.createElement("div", {
      className: getClassNames('form-layout-row-sub')
    }, /*#__PURE__*/React.createElement(InfoCircleOutlined, null), /*#__PURE__*/React.createElement("span", null, "Enter each domain on a separate line that should be allowed in notification landing URLs. Leave blank to allow all domains.")))), /*#__PURE__*/React.createElement(Well, {
      title: "Button Defaults",
      mode: "ghost",
      hideFooter: true
    }, defaultOpenUrlLabelEnabled && /*#__PURE__*/React.createElement(Form.Item, {
      label: "Open URL Label",
      name: "defaultOpenUrlLabel",
      className: getClassNames('ddf-notif-editor-action-label'),
      rules: [{
        required: true,
        message: 'The default Open URL label cannot be empty.'
      }]
    }, /*#__PURE__*/React.createElement(Input, {
      size: "middle"
    })), /*#__PURE__*/React.createElement(Form.Item, {
      label: "Buttons",
      shouldUpdate: true
    }, /*#__PURE__*/React.createElement("div", {
      className: getClassNames('notif-action-builder-collection')
    }, /*#__PURE__*/React.createElement(NotifActionBuilder, {
      domain: domain,
      enabled: true,
      removable: true,
      removeLabel: "reset",
      title: "Button 1",
      addActionIcon: /*#__PURE__*/React.createElement(SettingOutlined, null),
      addActionText: "Set Button 1",
      config: primaryAction,
      onChange: handleActionUpdate,
      onRemove: handleActionRemove,
      onAdd: handlePrimaryActionAdd,
      rootActions: rootActions,
      customMacroOptions: waitForDefined(function () {
        return customMacroOptions;
      })
    }), /*#__PURE__*/React.createElement(NotifActionBuilder, {
      domain: domain,
      enabled: !!secondaryAction,
      removable: true,
      title: "Button 2",
      addActionIcon: /*#__PURE__*/React.createElement(SettingOutlined, null),
      addActionText: "Set Button 2",
      config: secondaryAction,
      onChange: handleActionUpdate,
      onRemove: handleActionRemove,
      onAdd: handleSecondaryActionAdd,
      rootActions: rootActions,
      customMacroOptions: waitForDefined(function () {
        return customMacroOptions;
      })
    })))), showInternalEditorAccess && /*#__PURE__*/React.createElement(Well, {
      title: "Delivery",
      mode: "ghost",
      hideFooter: true
    }, /*#__PURE__*/React.createElement(TtlEditorElement, {
      entity: {
        displayMeta: domain.displayMeta,
        defaultNotificationTtlSeconds: domain.defaultNotificationTtlSeconds
      }
    }), /*#__PURE__*/React.createElement(DomainDeliveryEditor, {
      entity: domain,
      form: form
    }), /*#__PURE__*/React.createElement(NotificationFrequencyCapsFormEditor, {
      enabled: capsEnabled,
      handleEnabled: setCapsEnabled
    }), /*#__PURE__*/React.createElement(DeliveryThrottlingEditor, {
      enabled: throttleEnabled,
      handleEnabled: setThrottleEnabled
    })), /*#__PURE__*/React.createElement(Well, {
      title: "Media",
      mode: "ghost",
      hideFooter: true
    }, showInternalEditorAccess && /*#__PURE__*/React.createElement(Form.Item, {
      name: "mediaQuality",
      label: "Upload Quality",
      className: getClassNames('ddf-notif-editor-media-quality'),
      rules: [{
        required: true,
        message: 'Media Quality is required.'
      }]
    }, /*#__PURE__*/React.createElement(Input, {
      type: "number",
      size: "middle",
      min: 30,
      max: 100
    })), /*#__PURE__*/React.createElement(Form.Item, {
      className: getClassNames('ddf-notif-editor-media-icon'),
      label: "Notification Icon"
    }, /*#__PURE__*/React.createElement(Form.Item, {
      name: "defaultIcon",
      noStyle: true,
      className: getClassNames('form-layout-row')
    }, /*#__PURE__*/React.createElement(FileUploader, {
      className: "icon-upload",
      type: "image",
      disabled: isChildDomain,
      ownerType: "domain",
      ownerId: domain.id,
      imageConfig: {
        cropMax: FileUploader.defaultDimensions.notificationIcon,
        cropRatio: 1,
        quality: (_domain$mediaQuality2 = domain.mediaQuality) !== null && _domain$mediaQuality2 !== void 0 ? _domain$mediaQuality2 : 40
      },
      onSuccess: noop,
      onRemove: noop,
      onError: function onError(res) {
        var error = res === null || res === void 0 ? void 0 : res.error;

        if (error && error.error_type === 'invalid_file_type_error') {
          return simpleNotification('error', error.message);
        }
      }
    })), isChildDomain ? /*#__PURE__*/React.createElement("div", {
      className: getClassNames('form-layout-row-sub')
    }, /*#__PURE__*/React.createElement(InfoCircleOutlined, null), /*#__PURE__*/React.createElement("span", null, "Icon cannot be updated on a test domain - Overlay Icon can be updated in the Details section.")) : /*#__PURE__*/React.createElement("div", {
      className: getClassNames('form-layout-row-sub')
    }, /*#__PURE__*/React.createElement(InfoCircleOutlined, null), /*#__PURE__*/React.createElement("span", null, "This icon will be shown for each push notification sent to a subscriber. Recommended size is 256x256 with an aspect ratio of 1:1."))), /*#__PURE__*/React.createElement(Form.Item, {
      className: getClassNames('ddf-notif-editor-media-badge'),
      label: "Notification Badge"
    }, /*#__PURE__*/React.createElement(Form.Item, {
      className: getClassNames('form-layout-row'),
      name: "defaultBadge",
      noStyle: true
    }, /*#__PURE__*/React.createElement(FileUploader, {
      className: "icon-upload",
      type: "image",
      ownerType: "domain",
      ownerId: domain.id,
      imageConfig: {
        cropMax: FileUploader.defaultDimensions.notificationBadge,
        cropRatio: 1,
        quality: (_domain$mediaQuality3 = domain.mediaQuality) !== null && _domain$mediaQuality3 !== void 0 ? _domain$mediaQuality3 : 40
      },
      onSuccess: noop,
      onRemove: noop,
      onError: function onError(res) {
        var error = res === null || res === void 0 ? void 0 : res.error;

        if (error && error.error_type === 'invalid_file_type_error') {
          return simpleNotification('error', error.message);
        }
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: getClassNames('form-layout-row-sub')
    }, /*#__PURE__*/React.createElement(InfoCircleOutlined, null), /*#__PURE__*/React.createElement("span", null, "Badges are only applicable to notifications delivered on Android. Images should use alpha transparency and all colors will be converted to black and white. Recommended size is 128x128 with and aspect ratio of 1:1.")))), /*#__PURE__*/React.createElement(Well, {
      title: "UTM Parameters",
      mode: "ghost",
      hideFooter: true
    }, domainUtmParameterKeys.map(function (key) {
      return /*#__PURE__*/React.createElement(Form.Item, {
        key: key,
        className: getClassNames("ddf-notif-editor-".concat(key)),
        name: camelCase(key),
        label: key
      }, /*#__PURE__*/React.createElement(TemplatizedTextField, {
        label: key,
        placeholder: key.replace('_', ' '),
        hideEmojis: true,
        macroTypes: utmMacroTypes,
        customMacroOptions: customMacroOptions,
        size: "small",
        noStyle: true
      }));
    })), /*#__PURE__*/React.createElement(Well, {
      key: customUtmParams.length,
      className: "custom-utm-parameter-well",
      title: "UTM Custom Parameters",
      mode: "ghost",
      actions: /*#__PURE__*/React.createElement(Button, {
        className: "custom-utm-add-btn",
        size: "small",
        onClick: handleCustomUtmAdd,
        disabled: Object.keys(customUtmParams).length >= 5
      }, /*#__PURE__*/React.createElement(PlusOutlined, null), /*#__PURE__*/React.createElement("span", null, "Add")),
      hideFooter: true
    }, customUtmParams.length === 0 && /*#__PURE__*/React.createElement("div", null, "There are no custom UTM parameters"), customUtmParams.map(function (_ref10, idx) {
      var _ref11 = _slicedToArray(_ref10, 2),
          name = _ref11[0],
          config = _ref11[1];

      return /*#__PURE__*/React.createElement("div", {
        ref: ref,
        key: idx,
        className: getClassNames('ddf-notif-editor-custom-utm')
      }, /*#__PURE__*/React.createElement(Input, {
        className: "custom-utm-name",
        size: "small",
        type: "text",
        placeholder: "Parameter name",
        defaultValue: name,
        onKeyDown: function onKeyDown(ev) {
          // we should attempt to prevent spaces in the query param name
          if (ev.key === ' ' || ev.keyCode === 32) {
            ev.preventDefault();
            ev.stopPropagation();
          }
        },
        onChange: function onChange(ev) {
          return handleCustomUtmChange(idx, ev.target.value, config["default"]);
        }
      }), /*#__PURE__*/React.createElement(TemplatizedTextField, {
        className: "custom-utm-value",
        size: "small",
        placeholder: "Parameter value",
        defaultValue: config["default"] || undefined,
        hideEmojis: true,
        macroTypes: utmMacroTypes,
        customMacroOptions: customMacroOptions,
        onChange: function onChange(val) {
          return handleCustomUtmChange(idx, name, val);
        }
      }), /*#__PURE__*/React.createElement(Button, {
        className: "custom-utm-remove-btn",
        size: "small",
        icon: /*#__PURE__*/React.createElement(DeleteFilled, null),
        onClick: function onClick() {
          return handleCustomUtmRemove(idx);
        }
      }));
    }))));
  }

  return render();
};
export default DomainNotificationEditor;